import React from 'react';
import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';
import PlacementInfo from './placementInfo';
import PlacementCardLayout from './placementCardLayout';

interface PendingPlacementCardProps {
  placement: AssociateProfilePlacement;
}

const PendingPlacementCard = ({ placement }: PendingPlacementCardProps) => (
  <PlacementCardLayout placement={placement}>
    <PlacementInfo label="Injury" value={placement.injury} />
    <PlacementInfo label="Start Date" value={new Date(placement.startAt).toLocaleDateString()} />
    <PlacementInfo label="End Date" value={new Date(placement.endAt).toLocaleDateString()} />
    <PlacementInfo label="Time In Pending" value={placement.timeInStatus} />
    <PlacementInfo label="Job(s)" value={placement.numSelectedJobs} />
  </PlacementCardLayout>
);

export default PendingPlacementCard;
